import React from 'react';
import { HourlyPremiumSection } from '../../shared/HourlyPremiumSection';


interface Props {
  holidayHourlyPremiumType?: 'percentage' | 'fixed' | null;
  onHolidayHourlyPremiumTypeChange?: (type: 'percentage' | 'fixed') => void;
  holidayPremiumBasis?: 'base_rate' | 'ot_inclusive';
  onHolidayPremiumBasisChange?: (basis: 'base_rate' | 'ot_inclusive') => void;
  holidayPremiumValueProps?: Record<string, unknown>;
  holidayPremiumValueError?: React.ReactNode;
  customizedFields: Record<string, boolean>;
  context: 'user' | 'client';
}

export const HourlyPremiumMethodSection: React.FC<Props> = ({
  holidayHourlyPremiumType,
  onHolidayHourlyPremiumTypeChange,
  holidayPremiumBasis,
  onHolidayPremiumBasisChange,
  holidayPremiumValueProps,
  holidayPremiumValueError,
  customizedFields,
  context,
}) => {
  return (
    <div className="space-y-4">
      <HourlyPremiumSection
          config={{
            premiumType: holidayHourlyPremiumType,
            premiumBasis: holidayPremiumBasis,
          }}
          onConfigChange={(updates) => {
            if (updates.premiumType !== undefined) {
              onHolidayHourlyPremiumTypeChange?.(updates.premiumType as 'percentage' | 'fixed');
            }
            if (updates.premiumBasis !== undefined) {
              onHolidayPremiumBasisChange?.(updates.premiumBasis);
            }
          }}
          premiumValueProps={holidayPremiumValueProps || {}}
          premiumValueError={holidayPremiumValueError}
          customizedFields={customizedFields}
          context={context}
        />
    </div>
  );
};
